import { useState, useMemo, useCallback, useLayoutEffect } from 'react';
import Enemies from './FIghtSceneEnemies/Enemies';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { fightSlice } from '../../store/reducers/FightReducer';
import UserCharacters from './FightnSceneCharacter/UserCharacters';
import FightSceneIsDead from './FightSceneExodus/FightScenIsDead';
import FightSceneIsWin from './FightSceneExodus/FightScenIsWin';
import Inventory from '../Inventory/Inventory';
import CharacterWindow from '../CharacterWindow/CharacterWindow';
import UserCharactersSkills from './FightnSceneCharacter/UserCharactersSkills';
import "./FightScene.scss"
import FightSceneHeaderPanel from './FightSceneHeaderPanel/FightSceneHeaderPanel';
import { uiSlice } from '../../store/reducers/uiReducer';
import { FightControllerDealDamage, IinitFightControllerArgs, initFightController, FightControllerSetSkillIndex } from '../../controllers/fightController';
import ImgWithFallback from '../ui/ImgWithFallback';

const FightScene = () => {
    //Redux const
    const dispatch = useAppDispatch()
    const mainCharacter = useAppSelector(state => state.userReducer.character)
    const location = useAppSelector(state => state.SceneReducer.currentLocation)
    const LocationsController = useAppSelector(state => state.SceneReducer.locations)
    const { setChoiceActive } = fightSlice.actions
    const { setChosenSkillIndex } = uiSlice.actions
    //useState const
    const [isWon, setIsWon] = useState(false)
    const [isLose, setIsLose] = useState(false)
    const [isInventoryOpen, setIsInventoryOpen] = useState(false)
    const [enemyArr, setEnemyArr] = useState(LocationsController.getEnemiesArr(location))
    const [playerHp, setPlayerHp] = useState(mainCharacter.getHp())
    const [enemiesHp, setEnemiesHP] = useState<number[]>(enemyArr.map(enemy => enemy.getHp()))
    const [isCharacterWindowOpen, setIsCharacterWindowOpen] = useState(false)
    //other const
    const fightOrder = [mainCharacter].concat(enemyArr)

    useLayoutEffect(() => {
        // player selectors
        const characterImgSelector = document.querySelector('.player__content-img')
        const characterContentBlockSelector = document.querySelector('.player__content')
        const characterTakenDamageSelector = document.querySelector('.player__content-taken-damage')
        // enemies selectors
        const enemiesImgSelector = document.querySelectorAll('.enemies__content-img')
        const enemiesContentBlockSelector = document.querySelectorAll('.enemies__content')
        const enemiesTakenDamageSelector = document.querySelectorAll('.player__content-taken-damage.enemies')

        const fightControllerProps: IinitFightControllerArgs = {
            character: mainCharacter,
            enemiesArr: enemyArr,
            initSelectors: {
                characterImgSelector: characterImgSelector,
                characterContentBlockSelector: characterContentBlockSelector,
                characterTakenDamageSelector: characterTakenDamageSelector,
                enemiesImgSelector: enemiesImgSelector,
                enemiesContentBlockSelector: enemiesContentBlockSelector,
                enemiesTakenDamageSelector: enemiesTakenDamageSelector
            },
            setIsWon: setIsWon,
            setIsLose: setIsLose,
            setPlayerHp: setPlayerHp,
            enemiesHp: enemiesHp,
            setEnemiesHP: setEnemiesHP,
            setEnemyArr: setEnemyArr
        }

        initFightController(fightControllerProps)
    })


    const handleSkillClick = (index: number) => {
        dispatch(setChosenSkillIndex(index))
        FightControllerSetSkillIndex(index)
        dispatch(setChoiceActive(true))
    }

    function handleCharacterClick(index: number) {
        FightControllerDealDamage(index)
        dispatch(setChosenSkillIndex(null))
    }

    const handleOpenCloseInventory = useCallback(() => {
        setIsInventoryOpen(!isInventoryOpen)
    }, [isInventoryOpen])

    const handleOpenCloseCharacterWindow = useCallback(() => {
        setIsCharacterWindowOpen(!isCharacterWindowOpen)
    }, [isCharacterWindowOpen])

    const getItems = useMemo(() => {
        return (
            isInventoryOpen ?
                <Inventory
                    closeInventory={handleOpenCloseInventory}
                    setPlayerHp={setPlayerHp}
                    classIfCharWindowOpen={isCharacterWindowOpen ? '_character-window-open' : ''} />
                :
                null
        )
    }, [isInventoryOpen, isCharacterWindowOpen])

    const getCharacterWindow = useMemo(() => {
        return (
            isCharacterWindowOpen ?
                <CharacterWindow
                    closeCharacterWindow={handleOpenCloseCharacterWindow}
                    classIfInventoryOpen={isInventoryOpen ? '_inventory-open' : ''} />
                :
                null
        )
    }, [isCharacterWindowOpen, isInventoryOpen])

    return (
        <div className="fight-scene__wrapper">
            <div className="fight-scene__main">
                <div className="fight-scene__main-backimg">
                    <ImgWithFallback
                        src={LocationsController.getLocationsSet()[location].getBackground().webp}
                        fallbackSrc={LocationsController.getLocationsSet()[location].getBackground().img} />
                </div>
                <div className="fight-scene__main-characters">
                    <UserCharacters playerHp={playerHp} isWon={isWon} />
                    <div className="enemies">
                        {enemyArr.map((item, i) => {
                            return (
                                <Enemies
                                    handleCharacterClick={handleCharacterClick}
                                    enemyImg={item.getImgBig()}
                                    enemyHp={item.getHp()}
                                    maxEnemyHp={item.getMaxHp()}
                                    enemyIndex={i}
                                    key={i}
                                />
                            )
                        })}
                    </div>
                </div>
                <UserCharactersSkills
                    fightOrder={fightOrder}
                    handleSkillClick={handleSkillClick} />
                <FightSceneHeaderPanel
                    handleOpenCloseCharacterWindow={handleOpenCloseCharacterWindow}
                    handleOpenCloseInventory={handleOpenCloseInventory} />
            </div>
            {getItems}
            {getCharacterWindow}
            {isLose ? <FightSceneIsDead /> : null}
            {isWon && <FightSceneIsWin />}
        </div>
    );
};

export default FightScene;
